var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandBye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 13.3069L7.573 3.65691C6.9933 3.09336 6.0665 3.10647 5.50295 3.68619C5.4825 3.70723 5.4627 3.72888 5.44355 3.75111C4.87206 4.41447 4.91128 5.4069 5.5333 6.0231L10.5454 10.9881",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 10.988L5.08865 5.57735C4.44176 4.93591 3.41005 4.90081 2.72107 5.4968C2.08777 6.0446 2.01847 7.00205 2.56628 7.63535C2.58705 7.6594 2.60857 7.68275 2.63082 7.7054L8.12765 13.3068",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12755 13.3068L4.99988 10.25C4.36871 9.6051 3.33647 9.5872 2.68329 10.2097C2.0371 10.8257 2.01257 11.8488 2.62849 12.495C2.63132 12.498 2.63417 12.5009 2.63703 12.5039C7.2518 17.2721 9.6469 19.5242 10.5454 20.2767C11.9999 21.4948 14.8674 22 16.3651 21C17.8629 20 19.2166 18.5772 19.8591 17.1643C20.2416 16.3232 20.9844 13.7297 22.0878 9.3839C22.3124 8.4993 21.7774 7.60005 20.8927 7.37545C20.8813 7.37255 20.8698 7.36975 20.8582 7.3671C19.9416 7.1552 19.0214 7.70575 18.7748 8.61365L17.4999 13.3068",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8578 6.3329C15.5018 5.8012 15.095 5.3065 14.6442 4.85569C14.1934 4.40489 13.6986 3.99803 13.167 3.64209C12.9024 3.46498 12.6287 3.30048 12.3467 3.14945C12.0663 2.99929 11.7778 2.86244 11.4819 2.73975",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59692 16.8879C2.92455 17.4375 3.30496 17.9529 3.73155 18.4267C4.15813 18.9004 4.6309 19.3326 5.14324 19.7159C5.39814 19.9066 5.66289 20.0852 5.93659 20.2508C6.20869 20.4154 6.48969 20.5672 6.77874 20.7052",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandBye);
export default __webpack_public_path__ + "static/media/hand-bye.643a2fee530b68c5406fcb44d2332743.svg";
export { ForwardRef as ReactComponent };